// tslint:disable:max-line-length
import { Inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { APP_CONFIG } from './config-injection';
import { AppConfig } from '../../_api';

@Injectable({
  providedIn: 'root',
})
export class OpenPopupService {
  constructor(
    @Inject(APP_CONFIG) public config: AppConfig,
    private dialog: MatDialog
  ) {}

  openPopup(url: any) {
    let newWin = window.open(url);

    if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
      const instructionsHtml = `<p>A popup blocker has been detected which is preventing you from
        being able to download documents and files. In order to download
        your documents and files, you'll need to disable your popup blocker for the
        app. To do this, you can follow the instructions
        for your browser from the list below. When prompted, you will need
        to add the following address to your "allowed" sites:  ${this.config.environment.url} </p>

        <h4>Browser Instructions</h4>
        <ul>
          <li>
            <a href="https://support.google.com/chrome/answer/95472?co=GENIE.Platform%3DDesktop&hl=en" target="_blank">Google Chrome</a>
            <div class="label label-success">RECOMMENDED</div>
          </li>
          <li>
            <a href="https://support.mozilla.org/en-US/kb/pop-blocker-settings-exceptions-troubleshooting#w_is-the-pop-up-blocker-on-and-enabled-for-this-site"
              target="_blank">Firefox</a>
          </li>
          <li>
            <a href="http://www.ncc.edu/programsandcourses/distance_ed_online/disable_popup_blocking.shtml" target="_blank">Safari</a>
          </li>
          <li>
            <a href="https://support.microsoft.com/en-us/help/17479/windows-internet-explorer-11-change-security-privacy-settings"
              target="_blank">Internet Explorer</a>
          </li>
      </ul>`;

      // TODO: Reimplement:
      // this.dialog.open(AlertModalComponent, {
      //   width: '70%',
      //   data: { title: 'Popup blocker detected.', message: instructionsHtml },
      // });
    }
  }
}
